// extracted by mini-css-extract-plugin
export var editButton = "_nd-0";